import { FunctionComponent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'

import { Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, 
  TableRow, IconButton, Divider, Tooltip } from '@mui/material';

import { getDaysString, capitalize } from 'utils/Common';

import Grid from '@mui/material/Grid2';
import EditIcon from '@mui/icons-material/Edit';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import useCollections, { CollectionState } from 'model/collection/CollectionStore';
import { CollectionModel } from 'model/collection/CollectionModels';

export class UpcomingCollectionProps {
  collection: CollectionModel;
}

const UpcomingCollection: FunctionComponent<UpcomingCollectionProps> = ({collection}) => {
  const navigate = useNavigate()
  const setCollection = useCollections((state: CollectionState) => state.setCollection);

  useEffect(() => {
    setCollection(collection)
  }, [collection, setCollection])
  
  const handleEdit = (collectionId: string) => {
    navigate(`/collection?id=${collectionId}`);
  };

  return (<>
  <Card variant='outlined'>
    <CardContent>
      <Typography variant="h5" gutterBottom marginBottom={1}>
        Upcoming
      </Typography>
      <Typography className='wizard-subtitle-color' variant="body1" gutterBottom sx={{ wordBreak: "break-word" }} marginBottom={1}>
        {"The next notification will be sent for "}
        <Link  to={"/collection?id="+collection.id} style={{textDecoration:"underline"}}>this collection</Link>
      </Typography>
      <Divider orientation="horizontal" flexItem sx={{mb:2, mr: -2, ml: -2}}/>
      
      <Grid container>
        <Grid size="grow">
      <Typography variant="h6">
        {collection.title}
      </Typography>
        </Grid>
        <Grid sx={{display: 'flex', gap: 1, alignItems: 'flex-start'}}>
          {!collection.tested && (
            <Tooltip title="The collection has not been tested, click edit to test it" arrow enterTouchDelay={0} leaveTouchDelay={3000}>
              <IconButton sx={{width: '40px', height: '40px'}}><WarningAmberIcon/></IconButton>
            </Tooltip>
          )}
          <IconButton sx={{width: '40px', height: '40px'}} onClick={(e) => handleEdit(collection.id)}><EditIcon/></IconButton>
        </Grid>
      </Grid>

      <TableContainer style={{marginTop: "5px", overflow: "hidden"}}>
        <Table>
          <TableBody>
            <TableRow > 
              <TableCell>Recipient</TableCell>
              <TableCell align="right">
                <Typography style={{wordBreak:"break-word", whiteSpace: "normal"}}>{collection.recipient}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{minWidth: "110px"}}>Next Reminder</TableCell>
              <TableCell align="right">{
                getDaysString(collection.daysUntilNext)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Amount</TableCell>
              <TableCell align="right">{`$${collection.amount.toLocaleString()}`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Schedule</TableCell>
              <TableCell align="right">{`${capitalize(collection.schedule)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <div style={{marginBottom: "-3px", marginTop: "17px", textAlign: "center"}}>
        <Link style={{ fontSize: 16 }} to={"/collections"}>
          <Typography variant="body1" style={{textDecoration:"underline"}}>
            See all configured collections
          </Typography>
        </Link>
      </div>
    </CardContent>
  </Card>
  </>);
}
export default UpcomingCollection;